import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '@/utils/api';
import { EyeIcon } from '@/ui/icons';

type Post = {
  id: string;
  title: string;
  contentHtml: string;
  coverImageUrl?: string;
  publishedAt?: string;
  category?: { name: string; slug: string };
  viewCount?: number;
};

export function PostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState<Post | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await api.get(`/api/public/post/${slug}`);
        if (!ignore) setPost(res.post ?? null);
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    // Track per-post view
    (async () => {
      try { await api.post(`/api/public/post_view/${slug}`, {}); if (!ignore) setPost((p) => p ? { ...p, viewCount: (p.viewCount ?? 0) + 1 } : p); } catch {}
    })();
    return () => {
      ignore = true;
    };
  }, [slug]);

  if (loading) return <div>Yükleniyor…</div>;
  if (!post) return <div>Yazı bulunamadı.</div>;

  return (
    <article className="mx-auto max-w-3xl">
      <header className="mb-6">
        {post.category && (
          <div className="text-sm text-brand-700">{post.category.name}</div>
        )}
        <h1 className="text-3xl font-serif font-bold mt-1">{post.title}</h1>
        <div className="flex items-center gap-3 text-sm text-gray-500 mt-1">
          {post.publishedAt && <span>{new Date(post.publishedAt).toLocaleDateString('tr-TR')}</span>}
          <span className="inline-flex items-center gap-1"><EyeIcon /> {post.viewCount ?? 0}</span>
        </div>
      </header>
      {post.coverImageUrl && (
        <img src={post.coverImageUrl} alt={post.title} className="rounded-lg mb-6 w-full object-cover" />
      )}
      <div className="tiptap" dangerouslySetInnerHTML={{ __html: post.contentHtml }} />
    </article>
  );
}


